import { createSlice } from '@reduxjs/toolkit';

export const UsersPermissionsSlice = createSlice({
    name: 'usersPermissions',
    initialState: {
        users_permissions_list: [],
        user_with_permissions: {}
    },
    reducers: {
        setUsersPemissionsRedux: ( state, { payload } ) => {
            state.users_permissions_list  =  payload;
        }, 
        setUserPemissionsRedux: ( state, { payload } ) => {
            state.user_with_permissions  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setUsersPemissionsRedux, setUserPemissionsRedux } = UsersPermissionsSlice.actions;